export const translations = {
  en: {
    companyName: "SUNNY SOFTWARE",
    ourApps: "our apps",
    
    // QuitSnus
    quitSnusTitle: "QuitSnus",
    quitSnusTagline: "Break free from snus addiction",
    quitSnusDescription: "Your personal journey to freedom from snus with AI-powered coaching, progress tracking, and daily motivation.",
    
    // QuitSmoking
    quitSmokingTitle: "QuitSmoking",
    quitSmokingTagline: "Quit smoking with your AI coach Sunny",
    quitSmokingDescription: "Break free from smoking addiction with personalized guidance, daily challenges, and support from Sunny, your AI-powered quit coach.",
    
    // Mr Piggy
    mrPiggyTitle: "Mr Piggy",
    mrPiggyTagline: "Smart budgeting made simple",
    mrPiggyDescription: "Take control of your finances with AI-powered budgeting, expense tracking, and personalized savings goals.",
    mrPiggyComingSoon: "Coming Soon!",
    countdownLabel: "Launching in",
    
    // Nero Diamante
    neroDiamanteTitle: "Nero Diamante",
    neroDiamanteTagline: "Interactive Digital Art",
    neroDiamanteDescription: "Experience the pinnacle of digital art with interactive prismatic effects, authentic ownership, and Swedish design excellence.",
    premiumLabel: "PREMIUM",
    
    // Common
    downloadOnAppStore: "Download on App Store",
    getItOnGooglePlay: "Get it on Google Play",
    aboutTitle: "About",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",
    screenshots: "Screenshots",
    language: "Language",
    back: "Back",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    
    // Features
    features: {
      aiCoach: "AI Coach",
      tracking: "Progress Tracking",
      challenges: "Daily Challenges",
      community: "Community Support",
      exclusivity: "Ultimate Exclusivity",
      interactive: "Interactive Art",
      certificate: "Authenticity Certificate",
      craftsmanship: "Swedish Craftsmanship"
    },
    
    // Contact Section
    contactTitle: "Get in Touch",
    contactSubtitle: "Have questions? We'd love to hear from you.",
    contactName: "Name",
    contactEmail: "Email",
    contactMessage: "Message",
    contactSend: "Send Message",
    contactSuccess: "Message sent successfully!",
    contactError: "Failed to send message. Please try again.",
    
    // Footer
    footerAbout: "About Us",
    footerApps: "Our Apps",
    footerSupport: "Support",
    footerLegal: "Legal",
    footerContact: "Contact",
    footerCopyright: "© 2025 Sunny Software. All rights reserved.",
    footerDescription: "Creating innovative apps that make a positive impact on people's lives.",
    
    // QuitSnus Privacy Policy
    quitSnusPrivacy: {
      title: "QuitSnus Privacy Policy",
      lastUpdated: "Last updated: June 26, 2025",
      sections: {
        intro: {
          title: "Introduction",
          content: "We, the developers of QuitSnus, take your privacy very seriously. This Privacy Policy explains how our mobile application QuitSnus collects, uses, and protects your information when you use our service to quit snus addiction."
        },
        dataCollection: {
          title: "Information We Collect",
          content: "To provide and improve our service, we collect information you provide directly, such as when you create an account, track your quit journey, or contact us for support. This includes your name, email address, quit date, usage patterns, progress data, mood logs, snus consumption tracking, and chat history with your AI coach. We also automatically collect technical data about your device and app usage."
        },
        dataUse: {
          title: "How We Use Your Information",
          content: "We use the information we collect to enable our core features, personalize your coaching experience, track your progress, send notifications and updates, provide customer support, and conduct research to enhance the app's effectiveness in helping you quit snus."
        },
        dataSharing: {
          title: "Information Sharing",
          content: "We do not sell or trade your personal information. We may share data with trusted service providers who assist in operating our app, provided they adhere to confidentiality obligations."
        },
        dataSecurity: {
          title: "Data Security",
          content: "We implement appropriate technical and organizational measures to protect your data against unauthorized access, alteration, disclosure, or destruction. All data is encrypted in transit and at rest using industry-standard protocols."
        },
        dataRetention: {
          title: "Data Retention",
          content: "We retain your personal data only as long as necessary to provide the service and as described in this policy. You can request deletion of your account and data at any time via the app settings or by contacting us."
        },
        yourRights: {
          title: "Your Rights",
          content: "Under GDPR, you have the right to access, correct, or delete your personal data. You may also object to certain processing activities or request a copy of your data in a machine-readable format. To exercise these rights, please contact us."
        },
        contact: {
          title: "Contact Us",
          content: "If you have any questions about this Privacy Policy, please contact us from the website."
        }
      }
    },
    
    // QuitSnus Terms
    quitSnusTerms: {
      title: "QuitSnus Terms of Use",
      lastUpdated: "Last updated: June 26, 2025",
      sections: {
        acceptance: {
          title: "Acceptance of Terms",
          content: "By downloading, accessing, or using the QuitSnus mobile application, you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our app."
        },
        description: {
          title: "Service Description",
          content: "QuitSnus is a mobile application designed to help users quit or reduce their snus consumption through AI-powered coaching, progress tracking, and personalized support."
        },
        userResponsibilities: {
          title: "User Responsibilities",
          content: "You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to provide accurate and complete information."
        },
        prohibitedUse: {
          title: "Prohibited Uses",
          content: "You may not use the app for any unlawful purpose or to solicit others to perform unlawful acts. You may not violate any applicable laws, harass or harm others, or attempt to gain unauthorized access to our systems."
        },
        intellectualProperty: {
          title: "Intellectual Property",
          content: "All content, features, and functionality of QuitSnus, including design, text, graphics, code, and AI components, are owned by Sunny Software or its licensors and are protected by intellectual property laws."
        },
        medicalDisclaimer: {
          title: "Medical Disclaimer",
          content: "QuitSnus is not a medical device and does not provide medical advice. Quitting snus may pose health risks, including nicotine withdrawal symptoms. Always consult a healthcare professional. Use this app at your own risk."
        },
        limitation: {
          title: "Limitation of Liability",
          content: "SUNNY SOFTWARE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE APP."
        },
        termination: {
          title: "Termination",
          content: "We may terminate or suspend your access to the app at any time, without notice or liability, if you breach these Terms or for any other reason."
        },
        changes: {
          title: "Changes to Terms",
          content: "We reserve the right to modify or replace these Terms at any time. Material changes will be communicated via the app with at least 30 days' notice before taking effect."
        },
        contact: {
          title: "Contact Information",
          content: "For questions about these Terms, contact via the form on our site."
        }
      }
    },
    
    // QuitSmoking Privacy Policy
    quitSmokingPrivacy: {
      title: "QuitSmoking Privacy Policy",
      lastUpdated: "Last updated: June 26, 2025",
      sections: {
        intro: {
          title: "Introduction",
          content: "We, the developers of QuitSmoking, take your privacy very seriously. This Privacy Policy explains how our mobile application QuitSmoking collects, uses, and protects your information when you use our service."
        },
        dataCollection: {
          title: "Information We Collect",
          content: "To provide and improve our service, we collect information you provide directly, such as when you create an account, track your quit journey, or contact us for support. This includes your name, email address, quit date, usage patterns, progress data, mood logs, and chat history with Sunny. We also automatically collect technical data about your device and app usage, including anonymous device type and language settings."
        },
        dataUse: {
          title: "How We Use Your Information",
          content: "We use the information we collect to enable our core features, personalize your coaching experience, track your progress, send notifications and updates, provide customer support, and conduct research to enhance the app's effectiveness in helping you quit smoking."
        },
        dataSharing: {
          title: "Information Sharing",
          content: "We do not sell or trade your personal information. We may share data with trusted service providers (e.g., Firebase, RevenueCat) who assist in operating our app, provided they adhere to confidentiality obligations."
        },
        dataSecurity: {
          title: "Data Security",
          content: "We implement appropriate technical and organizational measures to protect your data against unauthorized access, alteration, disclosure, or destruction. All data is encrypted in transit and at rest using industry-standard protocols."
        },
        dataRetention: {
          title: "Data Retention",
          content: "We retain your personal data only as long as necessary to provide the service and as described in this policy. You can request deletion of your account and data at any time via the app settings or by contacting us."
        },
        yourRights: {
          title: "Your Rights",
          content: "Under GDPR, you have the right to access, correct, or delete your personal data. You may also object to certain processing activities or request a copy of your data in a machine-readable format. To exercise these rights, please contact us."
        },
        contact: {
          title: "Contact Us",
          content: "If you have any questions about this Privacy Policy, please contact us from the website."
        }
      }
    },
    
    // QuitSmoking Terms of Use
    quitSmokingTerms: {
      title: "QuitSmoking Terms of Use",
      lastUpdated: "Last updated: June 26, 2025",
      sections: {
        acceptance: {
          title: "Acceptance of Terms",
          content: "By downloading, accessing, or using the QuitSmoking mobile application, you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our app."
        },
        description: {
          title: "Service Description",
          content: "QuitSmoking is a mobile application designed to help users quit or reduce their smoking through AI-powered coaching, progress tracking, and personalized support. The app provides motivational tools, educational content, and community features to support your quit journey."
        },
        userResponsibilities: {
          title: "User Responsibilities",
          content: "You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to provide accurate and complete information and to update it as necessary."
        },
        prohibitedUse: {
          title: "Prohibited Uses",
          content: "You may not use the app for any unlawful purpose or to solicit others to perform unlawful acts. You may not violate any applicable laws, harass or harm others, or attempt to gain unauthorized access to our systems."
        },
        intellectualProperty: {
          title: "Intellectual Property",
          content: "All content, features, and functionality of QuitSmoking, including design, text, graphics, code, and AI components, are owned by Sunny Software or its licensors and are protected by intellectual property laws."
        },
        medicalDisclaimer: {
          title: "Medical Disclaimer",
          content: "QuitSmoking is not a medical device and does not provide medical advice. Quitting smoking may pose health risks, including nicotine withdrawal symptoms and other medical complications. Always consult a healthcare professional before quitting. Use this app at your own risk. We disclaim all liability for any harm arising from your use of the app."
        },
        limitation: {
          title: "Limitation of Liability",
          content: "SUNNY SOFTWARE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING LOSS OF PROFITS, DATA, OR OTHER INTANGIBLE LOSSES, ARISING OUT OF OR RELATED TO YOUR USE OF THE APP."
        },
        termination: {
          title: "Termination",
          content: "We may terminate or suspend your access to the app at any time, without notice or liability, if you breach these Terms or for any other reason."
        },
        changes: {
          title: "Changes to Terms",
          content: "We reserve the right to modify or replace these Terms at any time. Material changes will be communicated via the app with at least 30 days' notice before taking effect."
        },
        contact: {
          title: "Contact Information",
          content: "For questions about these Terms, contact via the form on our site."
        }
      }
    },
    
    // Mr Piggy Privacy Policy
    mrPiggyPrivacy: {
      title: "Mr Piggy Privacy Policy",
      lastUpdated: "Last updated: June 26, 2025",
      sections: {
        intro: {
          title: "Introduction",
          content: "At Sunny Software, we prioritize your privacy. This Privacy Policy outlines how our mobile application Mr Piggy collects, uses, and safeguards your information when you use our service."
        },
        dataCollection: {
          title: "Information We Collect",
          content: "We collect information you provide directly, such as when you set up an account, track your expenses, or contact us for support. This may include your name, email address, financial goals, transaction data, and budgeting preferences. We also automatically collect device information and app usage statistics, including device identifiers and operating system details."
        },
        dataUse: {
          title: "How We Use Your Information",
          content: "We use your information to provide, maintain, and enhance our services, including personalizing your budgeting experience, tracking your financial progress, sending notifications, providing customer support, and conducting research to improve our app's functionality."
        },
        dataSharing: {
          title: "Information Sharing",
          content: "We do not sell or share your personal information with third parties without your consent, except as outlined in this policy. We may share data with trusted service providers who assist in operating our app, ensuring they maintain confidentiality."
        },
        dataSecurity: {
          title: "Data Security",
          content: "We employ robust security measures to protect your information from unauthorized access, alteration, or disclosure. All data is encrypted in transit and at rest using industry-standard protocols."
        },
        dataRetention: {
          title: "Data Retention",
          content: "We retain your information only as long as necessary to provide our services. You can request deletion of your account and data through the app settings or by contacting us."
        },
        yourRights: {
          title: "Your Rights",
          content: "You have the right to access, update, or delete your personal information. You can also opt out of certain communications. Contact us to exercise these rights."
        },
        contact: {
          title: "Contact Us",
          content: "For questions about this Privacy Policy, contact us from the website."
        }
      }
    },
    
    // Mr Piggy Terms of Use
    mrPiggyTerms: {
      title: "Mr Piggy Terms of Use",
      lastUpdated: "Last updated: June 26, 2025",
      sections: {
        acceptance: {
          title: "Acceptance of Terms",
          content: "By downloading, accessing, or using the Mr Piggy mobile application, you agree to be bound by these Terms of Use. If you do not agree, please do not use our app."
        },
        description: {
          title: "Service Description",
          content: "Mr Piggy is a mobile application designed to help users manage their finances through AI-powered budgeting, expense tracking, and goal setting. The app offers tools to promote financial wellness and savings."
        },
        userResponsibilities: {
          title: "User Responsibilities",
          content: "You are responsible for maintaining the confidentiality of your account and for all activities under your account. You agree to provide accurate financial information and update it as necessary."
        },
        prohibitedUse: {
          title: "Prohibited Uses",
          content: "You may not use our app for any unlawful purpose or to engage in activities that violate any local, state, national, or international law. You may not attempt to gain unauthorized access to our systems."
        },
        intellectualProperty: {
          title: "Intellectual Property",
          content: "The Mr Piggy app and its content, features, and functionality are owned by Sunny Software and protected by international copyright, trademark, patent, and other intellectual property laws."
        },
        disclaimer: {
          title: "Financial Disclaimer",
          content: "Mr Piggy is not a financial advisory service and should not replace professional financial advice. Consult with financial professionals for advice related to your financial decisions."
        },
        limitation: {
          title: "Limitation of Liability",
          content: "Sunny Software shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the app."
        },
        termination: {
          title: "Termination",
          content: "We may terminate or suspend your account and access to the app without prior notice for any reason, including if you breach these Terms."
        },
        changes: {
          title: "Changes to Terms",
          content: "We reserve the right to modify these Terms at any time. Material changes will be communicated with at least 30 days notice."
        },
        contact: {
          title: "Contact Information",
          content: "Questions about the Terms of Use should be sent to us from the website."
        }
      }
    },
    
    // Nero Diamante Privacy Policy
    neroDiamantePrivacy: {
      title: "Nero Diamante Privacy Policy",
      lastUpdated: "Last updated: June 26, 2025",
      sections: {
        intro: {
          title: "Introduction",
          content: "Nero Diamante represents the pinnacle of digital art privacy. We collect minimal data to provide you with an exclusive, secure digital art experience while maintaining the highest standards of privacy protection."
        },
        dataCollection: {
          title: "Information We Collect",
          content: "We collect only essential information: your name, email address for authenticity verification, purchase confirmation, certificate generation, device interactions with the digital art piece, and support communications. We do not collect biometric data, location information, or personal behavioral patterns beyond art interaction."
        },
        dataUse: {
          title: "How We Use Your Information",
          content: "Your information is used exclusively to: verify ownership authenticity, generate and maintain your certificate of authenticity, provide premium customer support, deliver software updates, and maintain the exclusivity registry of all 1000 pieces."
        },
        dataSharing: {
          title: "Information Sharing",
          content: "We never sell or share your data. Your ownership and identity remain confidential. We may share minimal technical data with trusted service providers solely for app functionality, under strict confidentiality agreements."
        },
        dataSecurity: {
          title: "Data Security",
          content: "Nero Diamante employs military-grade encryption for all data. Your ownership certificate and personal information are stored using advanced cryptographic protection. All communications are secured with end-to-end encryption."
        },
        exclusivity: {
          title: "Exclusivity Protection",
          content: "Your position in the exclusive 1000-piece collection is permanently recorded and protected. Ownership data is maintained with blockchain-level security to ensure authentic provenance and prevent counterfeiting."
        },
        dataRetention: {
          title: "Data Retention",
          content: "Ownership records are retained permanently to maintain authenticity and value. Personal contact information is retained only as long as you own the digital art piece. You may request data updates but ownership history remains for authenticity."
        },
        yourRights: {
          title: "Your Rights",
          content: "As a premium owner, you have enhanced rights: access to all ownership data, ability to update contact information, transfer ownership records, and request premium privacy consultations. Ownership itself cannot be deleted as it's part of the permanent exclusivity record."
        },
        contact: {
          title: "Contact Us",
          content: "For premium privacy support, contact us from the website. Premium owners receive priority privacy assistance."
        }
      }
    },
    
    // Nero Diamante Terms of Use
    neroDiamanteTerms: {
      title: "Nero Diamante Terms of Use",
      lastUpdated: "Last updated: June 26, 2025",
      sections: {
        acceptance: {
          title: "Acceptance of Terms",
          content: "By purchasing and using Nero Diamante, you agree to these exclusive Terms of Use. These terms govern your ownership and use of this limited digital art piece."
        },
        exclusivity: {
          title: "Exclusivity Agreement",
          content: "Nero Diamante is limited to exactly 1000 pieces worldwide. Your purchase grants you exclusive ownership of one unique piece, identified by your personal certificate number. No additional pieces will ever be created beyond this limit."
        },
        ownership: {
          title: "Digital Ownership Rights",
          content: "You own exclusive rights to your specific Nero Diamante piece, including: permanent access to the interactive art experience, transfer rights to future owners, authentic certificate of ownership, and lifetime software updates and premium support."
        },
        usage: {
          title: "Permitted Use",
          content: "You may use your Nero Diamante for personal enjoyment, display, collection, and transfer to other parties. You may not reproduce, copy, distribute, or create derivative works from the digital art for commercial purposes."
        },
        transfers: {
          title: "Ownership Transfer",
          content: "Nero Diamante ownership may be transferred to other parties. Transfer requires identity verification and results in permanent record updates. Transfer fees may apply. The new owner receives full ownership rights and updated certificates."
        },
        authenticity: {
          title: "Authenticity Guarantee",
          content: "Each Nero Diamante comes with a certificate of authenticity guaranteed by Sunny Software. Counterfeiting or unauthorized reproduction is strictly prohibited and may result in legal action."
        },
        value: {
          title: "Value and Investment",
          content: "While Nero Diamante represents premium digital art, Sunny Software makes no guarantees about future value or investment returns. Digital art value may fluctuate based on market conditions and demand."
        },
        technical: {
          title: "Technical Requirements",
          content: "Nero Diamante requires compatible iOS devices for optimal experience. Software updates will be provided to maintain compatibility and enhance features. Premium technical support is included with ownership."
        },
        limitation: {
          title: "Limitation of Liability",
          content: "Sunny Software's liability is limited to the original purchase price. We are not liable for any indirect damages, lost profits, or consequential damages related to ownership or use of Nero Diamante."
        },
        termination: {
          title: "Termination",
          content: "These terms remain in effect as long as you own your Nero Diamante piece. Sunny Software may terminate support services for violations of these terms, but your ownership rights remain intact."
        },
        changes: {
          title: "Changes to Terms",
          content: "We reserve the right to modify these Terms. Material changes affecting ownership rights will be communicated with at least 90 days notice to all current owners."
        },
        contact: {
          title: "Contact Information",
          content: "For questions about these Terms or ownership matters, contact us from the website. Premium owners receive expedited support."
        }
      }
    }
  },
  
  sv: {
    companyName: "SUNNY SOFTWARE",
    ourApps: "våra appar",
    
    // QuitSnus
    quitSnusTitle: "QuitSnus",
    quitSnusTagline: "Bli fri från snusberoende",
    quitSnusDescription: "Din personliga resa till frihet från snus med AI-driven coaching, framstegsföljning och daglig motivation.",
    
    // QuitSmoking
    quitSmokingTitle: "QuitSmoking",
    quitSmokingTagline: "Sluta röka med din AI-coach Sunny",
    quitSmokingDescription: "Bli fri från rökberoende med personlig vägledning, dagliga utmaningar och stöd från Sunny, din AI-drivna coach.",
    
    // Mr Piggy
    mrPiggyTitle: "Mr Piggy",
    mrPiggyTagline: "Smart budgetering gjord enkelt",
    mrPiggyDescription: "Ta kontroll över din ekonomi med AI-driven budgetering, utgiftsspårning och personliga sparmål.",
    mrPiggyComingSoon: "Kommer snart!",
    countdownLabel: "Lanseras om",
    
    // Nero Diamante
    neroDiamanteTitle: "Nero Diamante",
    neroDiamanteTagline: "Interaktiv digital konst",
    neroDiamanteDescription: "Upplev toppen av digital konst med interaktiva prismatiska effekter, äkta ägande och svensk designexcellens.",
    premiumLabel: "PREMIUM",
    
    // Common
    downloadOnAppStore: "Hämta på App Store",
    getItOnGooglePlay: "Tillgänglig på Google Play",
    aboutTitle: "Om",
    privacyPolicy: "Sekretesspolicy",
    termsOfUse: "Användarvillkor",
    screenshots: "Skärmbilder",
    language: "Språk",
    back: "Tillbaka",
    days: "Dagar",
    hours: "Timmar",
    minutes: "Minuter",
    seconds: "Sekunder",
    
    // Features
    features: {
      aiCoach: "AI-Coach",
      tracking: "Framstegsföljning",
      challenges: "Dagliga Utmaningar",
      community: "Community Support",
      exclusivity: "Ultimat Exklusivitet",
      interactive: "Interaktiv Konst",
      certificate: "Äkthetscertifikat",
      craftsmanship: "Svenskt Hantverk"
    },
    
    // Contact Section
    contactTitle: "Kontakta Oss",
    contactSubtitle: "Har du frågor? Vi vill gärna höra från dig.",
    contactName: "Namn",
    contactEmail: "E-post",
    contactMessage: "Meddelande",
    contactSend: "Skicka Meddelande",
    contactSuccess: "Meddelandet skickades!",
    contactError: "Misslyckades att skicka meddelandet. Försök igen.",
    
    // Footer
    footerAbout: "Om Oss",
    footerApps: "Våra Appar",
    footerSupport: "Support",
    footerLegal: "Juridiskt",
    footerContact: "Kontakt",
    footerCopyright: "© 2025 Sunny Software. Alla rättigheter förbehållna.",
    footerDescription: "Vi skapar innovativa appar som gör en positiv skillnad i människors liv.",
    
    // QuitSnus Privacy Policy
    quitSnusPrivacy: {
      title: "QuitSnus Sekretesspolicy",
      lastUpdated: "Senast uppdaterad: 26 juni 2025",
      sections: {
        intro: {
          title: "Introduktion",
          content: "Vi som utvecklat QuitSnus tar din integritet på största allvar. Den här sekretesspolicyn förklarar hur vår mobilapplikation QuitSnus samlar in, använder och skyddar din information när du använder vår tjänst för att sluta med snus."
        },
        dataCollection: {
          title: "Information Vi Samlar In",
          content: "För att tillhandahålla och förbättra vår tjänst samlar vi in information du tillhandahåller direkt, såsom när du skapar ett konto, följer din resa att sluta eller kontaktar oss för support. Detta inkluderar ditt namn, e-postadress, slutdatum, användningsmönster, framstegsdata, humörloggar, snuskonsumtionsspårning och chatthistorik med din AI-coach."
        },
        dataUse: {
          title: "Hur Vi Använder Din Information",
          content: "Vi använder informationen vi samlar in för att möjliggöra våra huvudfunktioner, personalisera din coachingupplevelse, spåra dina framsteg, skicka notifieringar och uppdateringar, ge kundsupport och bedriva forskning för att förbättra appens effektivitet i att hjälpa dig sluta med snus."
        },
        dataSharing: {
          title: "Informationsdelning",
          content: "Vi säljer eller handlar inte med din personliga information. Vi kan dela data med betrodda tjänsteleverantörer som hjälper till att driva vår app, förutsatt att de följer konfidentialitetsförpliktelser."
        },
        dataSecurity: {
          title: "Datasäkerhet",
          content: "Vi implementerar lämpliga tekniska och organisatoriska åtgärder för att skydda din data mot obehörig åtkomst, ändring, avslöjande eller förstörelse. All data krypteras under transport och i vila med branschstandardprotokoll."
        },
        dataRetention: {
          title: "Datalagring",
          content: "Vi behåller din personliga data endast så länge som nödvändigt för att tillhandahålla tjänsten och som beskrivs i denna policy. Du kan begära radering av ditt konto och data när som helst via appinställningarna eller genom att kontakta oss."
        },
        yourRights: {
          title: "Dina Rättigheter",
          content: "Under GDPR har du rätt att komma åt, korrigera eller radera din personliga data. Du kan också invända mot vissa behandlingsaktiviteter eller begära en kopia av din data i maskinläsbart format. För att utöva dessa rättigheter, vänligen kontakta oss."
        },
        contact: {
          title: "Kontakta Oss",
          content: "Om du har några frågor om denna sekretesspolicy, vänligen kontakta oss från hemsidan."
        }
      }
    },
    
    // QuitSnus Terms
    quitSnusTerms: {
      title: "QuitSnus Användarvillkor",
      lastUpdated: "Senast uppdaterad: 26 juni 2025",
      sections: {
        acceptance: {
          title: "Acceptans av Villkor",
          content: "Genom att ladda ner, komma åt eller använda QuitSnus mobilapplikation, samtycker du till att vara bunden av dessa användarvillkor. Om du inte godkänner dessa villkor, vänligen använd inte vår app."
        },
        description: {
          title: "Tjänstbeskrivning",
          content: "QuitSnus är en mobilapplikation utformad för att hjälpa användare att sluta eller minska sin snuskonsumtion genom AI-driven coaching, framstegsföljning och personligt stöd."
        },
        userResponsibilities: {
          title: "Användaransvar",
          content: "Du är ansvarig för att upprätthålla konfidentialiteten för dina kontouppgifter och för alla aktiviteter som sker under ditt konto. Du samtycker till att tillhandahålla korrekt och fullständig information."
        },
        prohibitedUse: {
          title: "Förbjuden Användning",
          content: "Du får inte använda appen för något olagligt syfte eller för att uppmana andra att utföra olagliga handlingar. Du får inte bryta mot tillämpliga lagar, trakassera eller skada andra, eller försöka få obehörig åtkomst till våra system."
        },
        intellectualProperty: {
          title: "Immateriella Rättigheter",
          content: "Allt innehåll, funktioner och funktionalitet i QuitSnus, inklusive design, text, grafik, kod och AI-komponenter, ägs av Sunny Software eller dess licensgivare och skyddas av lagar om immateriella rättigheter."
        },
        medicalDisclaimer: {
          title: "Medicinsk Ansvarsfriskrivning",
          content: "QuitSnus är inte en medicinteknisk produkt och ger inte medicinsk rådgivning. Att sluta med snus kan medföra hälsorisker, inklusive nikotinabstinens. Rådgör alltid med vårdpersonal. Använd denna app på egen risk."
        },
        limitation: {
          title: "Ansvarsbegränsning",
          content: "SUNNY SOFTWARE SKA INTE VARA ANSVARIGA FÖR NÅGRA INDIREKTA, TILLFÄLLIGA, SPECIELLA, FÖLJD- ELLER STRAFFSKADOR SOM UPPSTÅR FRÅN ELLER RELATERAR TILL DIN ANVÄNDNING AV APPEN."
        },
        termination: {
          title: "Uppsägning",
          content: "Vi kan avsluta eller stänga av din åtkomst till appen när som helst, utan förvarning eller ansvar, om du bryter mot dessa villkor eller av någon annan anledning."
        },
        changes: {
          title: "Ändringar av Villkor",
          content: "Vi förbehåller oss rätten att ändra eller ersätta dessa villkor när som helst. Väsentliga ändringar kommer att kommuniceras via appen med minst 30 dagars varsel innan de träder i kraft."
        },
        contact: {
          title: "Kontaktinformation",
          content: "För frågor om dessa villkor, kontakta via formuläret på vår webbplats."
        }
      }
    },
    
    // Swedish QuitSmoking Privacy Policy
    quitSmokingPrivacy: {
      title: "QuitSmoking Sekretesspolicy",
      lastUpdated: "Senast uppdaterad: 26 juni 2025",
      sections: {
        intro: {
          title: "Introduktion",
          content: "Vi som utvecklat QuitSmoking tar din integritet på största allvar. Den här appen är byggd med målet att hjälpa dig sluta röka eller trappa ner – inte att samla in data i onödan. All information du ger oss behandlas enligt EU:s dataskyddsförordning (GDPR)."
        },
        dataCollection: {
          title: "Vilka uppgifter vi samlar in",
          content: "För att du ska kunna använda appen och få en personlig upplevelse samlar vi in följande uppgifter: namn, e-postadress, datum för rökfrihet, återfall, humörloggar, egna mål och utmaningar, antal cigaretter, sparade kronor, sparmål, milstolpar, anteckningar i kalendern, poäng, topplista (valfritt) och chatt med Sunny. Vi samlar inte in platsdata, IP-adresser eller enhets-ID."
        },
        dataUse: {
          title: "Hur vi använder uppgifterna",
          content: "Vi använder dina uppgifter för att möjliggöra inloggning, leverera personligt stöd via AI-coachen Sunny, visa relevant statistik, skicka pushnotiser, hantera topplistor och dagliga utmaningar samt förbättra appens funktionalitet."
        },
        dataSharing: {
          title: "Informationsdelning",
          content: "Vi delar inte dina uppgifter med tredje part för marknadsföring eller försäljning. Vi kan dela anonymiserad data med betrodda tjänsteleverantörer (t.ex. Firebase, RevenueCat) som stödjer appens drift, under förutsättning att de följer konfidentialitetsavtal."
        },
        dataSecurity: {
          title: "Datasäkerhet",
          content: "Alla data lagras krypterat i transit och vila på EU-baserade servrar i Firebase. Vi vidtar tekniska och organisatoriska åtgärder för att skydda dina uppgifter mot obehörig åtkomst, ändring eller förstörelse."
        },
        dataRetention: {
          title: "Datalagring",
          content: "Vi sparar dina uppgifter så länge ditt konto är aktivt eller tills du begär radering. Du kan när som helst radera ditt konto eller be oss ta bort dina data via appinställningarna eller kontakt."
        },
        yourRights: {
          title: "Dina rättigheter",
          content: "Enligt GDPR har du rätt att få tillgång till, korrigera eller radera dina personuppgifter, invända mot viss behandling samt få ut dina data i maskinläsbart format. Kontakta oss för att utöva dina rättigheter."
        },
        contact: {
          title: "Kontakta oss",
          content: "Vid frågor om sekretesspolicyn, kontakta oss via hemsidan."
        }
      }
    },
    
    // Swedish QuitSmoking Terms of Use
    quitSmokingTerms: {
      title: "QuitSmoking Användarvillkor",
      lastUpdated: "Senast uppdaterad: 26 juni 2025",
      sections: {
        acceptance: {
          title: "Acceptans av villkoren",
          content: "Genom att ladda ner, installera eller använda QuitSmoking godkänner du dessa villkor. Om du inte godkänner dem får du inte använda appen."
        },
        serviceDescription: {
          title: "Tjänstbeskrivning",
          content: "QuitSmoking är en app som hjälper dig att sluta röka eller trappa ner din användning genom AI-driven coaching, framstegsföljning och personligt stöd."
        },
        userResponsibilities: {
          title: "Användaransvar",
          content: "Du ansvarar för att hålla dina inloggningsuppgifter säkra och att informationen du lämnar är korrekt. Du får inte dela eller överlåta ditt konto."
        },
        prohibitedUse: {
          title: "Förbjuden användning",
          content: "Du får inte använda appen för olagliga ändamål, trakassera andra, eller försöka få obehörig åtkomst till våra system."
        },
        intellectualProperty: {
          title: "Immateriella rättigheter",
          content: "Allt innehåll i appen, inklusive design, text, grafik och AI-funktioner, tillhör Sunny Software eller våra licensgivare och skyddas av upphovsrätt och annan immaterialrätt."
        },
        medicalDisclaimer: {
          title: "Medicinsk ansvarsfriskrivning",
          content: "QuitSmoking är inte en medicinteknisk produkt och ger inte medicinsk rådgivning. Att sluta röka kan medföra hälsorisker, inklusive nikotinabstinens och andra medicinska komplikationer. Kontakta alltid vårdpersonal innan du slutar röka. Använd appen på egen risk. Vi friskriver oss från allt ansvar för eventuell skada som uppstår genom användning av appen."
        },
        limitation: {
          title: "Ansvarsbegränsning",
          content: "Vi ansvarar inte för direkta eller indirekta skador eller förluster som uppstår genom användning av appen."
        },
        termination: {
          title: "Uppsägning",
          content: "Vi kan när som helst avsluta eller stänga av ditt konto om du bryter mot villkoren, utan förvarning."
        },
        changes: {
          title: "Ändringar av villkoren",
          content: "Vi förbehåller oss rätten att ändra dessa villkor när som helst. Väsentliga ändringar meddelas via appen med 30 dagars varsel."
        },
        contact: {
          title: "Kontaktinformation",
          content: "Frågor om villkoren skickas via hemsidans formulär"
        }
      }
    },
    
    // Mr Piggy Privacy Policy
    mrPiggyPrivacy: {
      title: "Mr Piggy Sekretesspolicy",
      lastUpdated: "Senast uppdaterad: 26 juni 2025",
      sections: {
        intro: {
          title: "Introduktion",
          content: "På Sunny Software prioriterar vi din integritet. Denna sekretesspolicy beskriver hur vår mobilapplikation Mr Piggy samlar in, använder och skyddar din information när du använder vår tjänst."
        },
        dataCollection: {
          title: "Information Vi Samlar In",
          content: "Vi samlar in information du tillhandahåller direkt, såsom när du skapar ett konto, spårar dina utgifter eller kontaktar oss för support. Detta kan inkludera ditt namn, e-postadress, finansiella mål, transaktionsdata och budgetpreferenser. Vi samlar också automatiskt in enhetsinformation och appanvändningsstatistik, inklusive enhetsidentifierare och operativsystemdetaljer."
        },
        dataUse: {
          title: "Hur Vi Använder Din Information",
          content: "Vi använder din information för att tillhandahålla, underhålla och förbättra våra tjänster, inklusive att personalisera din budgetupplevelse, spåra dina finansiella framsteg, skicka aviseringar, ge kundsupport och bedriva forskning för att förbättra appens funktionalitet."
        },
        dataSharing: {
          title: "Informationsdelning",
          content: "Vi säljer eller delar inte din personliga information med tredje parter utan ditt samtycke, förutom som beskrivs i denna policy. Vi kan dela data med betrodda tjänsteleverantörer som hjälper till att driva vår app, förutsatt att de upprätthåller konfidentialitet."
        },
        dataSecurity: {
          title: "Datasäkerhet",
          content: "Vi använder robusta säkerhetsåtgärder för att skydda din information från obehörig åtkomst, ändring eller avslöjande. All data krypteras under transport och i vila med branschstandardprotokoll."
        },
        dataRetention: {
          title: "Datalagring",
          content: "Vi behåller din information endast så länge som nödvändigt för att tillhandahålla våra tjänster. Du kan begära radering av ditt konto och data genom appinställningarna eller genom att kontakta oss."
        },
        yourRights: {
          title: "Dina Rättigheter",
          content: "Du har rätt att komma åt, uppdatera eller radera din personliga information. Du kan också välja bort vissa kommunikationer. Kontakta oss för att utöva dessa rättigheter."
        },
        contact: {
          title: "Kontakta Oss",
          content: "För frågor om denna sekretesspolicy, kontakta oss via hemsidan."
        }
      }
    },
    
    // Mr Piggy Terms of Use
    mrPiggyTerms: {
      title: "Mr Piggy Användarvillkor",
      lastUpdated: "Senast uppdaterad: 26 juni 2025",
      sections: {
        acceptance: {
          title: "Acceptans av Villkor",
          content: "Genom att ladda ner, komma åt eller använda Mr Piggy mobilapplikation, samtycker du till att vara bunden av dessa användarvillkor. Om du inte godkänner dessa villkor, vänligen använd inte vår app."
        },
        description: {
          title: "Tjänstbeskrivning",
          content: "Mr Piggy är en mobilapplikation utformad för att hjälpa användare hantera sina finanser genom AI-driven budgetering, utgiftsspårning och målsättning. Appen erbjuder verktyg för att främja ekonomiskt välbefinnande och besparingar."
        },
        userResponsibilities: {
          title: "Användaransvar",
          content: "Du är ansvarig för att upprätthålla konfidentialiteten för ditt konto och för alla aktiviteter under ditt konto. Du samtycker till att tillhandahålla korrekt finansiell information och uppdatera den vid behov."
        },
        prohibitedUse: {
          title: "Förbjuden Användning",
          content: "Du får inte använda vår app för något olagligt syfte eller för att utföra aktiviteter som bryter mot någon lokal, statlig, nationell eller internationell lag. Du får inte försöka få obehörig åtkomst till våra system."
        },
        intellectualProperty: {
          title: "Immateriella Rättigheter",
          content: "Mr Piggy-appen och dess innehåll, funktioner och funktionalitet ägs av Sunny Software och skyddas av internationella upphovsrätt, varumärke, patent och andra lagar om immateriella rättigheter."
        },
        disclaimer: {
          title: "Finansiell Ansvarsfriskrivning",
          content: "Mr Piggy är inte en finansiell rådgivningstjänst och bör inte ersätta professionell finansiell rådgivning. Rådgör med finansiella proffs för råd relaterade till dina finansiella beslut."
        },
        limitation: {
          title: "Ansvarsbegränsning",
          content: "Sunny Software ska inte vara ansvariga för några indirekta, tillfälliga, speciella, följdskador eller straffskador till följd av din användning av appen."
        },
        termination: {
          title: "Uppsägning",
          content: "Vi kan avsluta eller stänga av ditt konto och åtkomst till appen utan förvarning för vilken anledning som helst, inklusive om du bryter mot dessa villkor."
        },
        changes: {
          title: "Ändringar av Villkor",
          content: "Vi förbehåller oss rätten att ändra dessa villkor när som helst. Väsentliga ändringar kommer att meddelas med minst 30 dagars varsel."
        },
        contact: {
          title: "Kontaktinformation",
          content: "Frågor om användarvillkoren ska skickas till oss via hemsidan."
        }
      }
    },
    
    // Nero Diamante Privacy Policy
    neroDiamantePrivacy: {
      title: "Nero Diamante Sekretesspolicy",
      lastUpdated: "Senast uppdaterad: 26 juni 2025",
      sections: {
        intro: {
          title: "Introduktion",
          content: "Nero Diamante representerar toppen av digital konstintegritet. Vi samlar in minimal data för att ge dig en exklusiv, säker digital konstupplevelse samtidigt som vi upprätthåller de högsta standarderna för integritetsskydd."
        },
        dataCollection: {
          title: "Information Vi Samlar In",
          content: "Vi samlar endast in väsentlig information: ditt namn, e-postadress för äkthetsverifiering, köpbekräftelse, certifikatgenerering, enhetsinteraktioner med det digitala konstverket och supportkommunikation. Vi samlar inte in biometrisk data, platsinformation eller personliga beteendemönster utöver konstinteraktion."
        },
        dataUse: {
          title: "Hur Vi Använder Din Information",
          content: "Din information används uteslutande för att: verifiera ägaräkthet, generera och underhålla ditt äkthetscertifikat, tillhandahålla premium kundsupport, leverera mjukvaruuppdateringar och underhålla exklusivitetsregistret för alla 1000 stycken."
        },
        dataSharing: {
          title: "Informationsdelning",
          content: "Vi säljer eller delar aldrig din data. Ditt ägande och din identitet förblir konfidentiella. Vi kan dela minimal teknisk data med betrodda tjänsteleverantörer enbart för appfunktionalitet, under strikta konfidentialitetsavtal."
        },
        dataSecurity: {
          title: "Datasäkerhet",
          content: "Nero Diamante använder militärklass kryptering för all data. Ditt ägarcertifikat och personlig information lagras med avancerat kryptografiskt skydd. All kommunikation säkras med end-to-end kryptering."
        },
        exclusivity: {
          title: "Exklusivitetsskydd",
          content: "Din position i den exklusiva 1000-styckessamlingen är permanent registrerad och skyddad. Ägardata underhålls med blockchain-nivå säkerhet för att säkerställa autentisk proveniens och förhindra förfalskning."
        },
        dataRetention: {
          title: "Datalagring",
          content: "Ägarregistreringar behålls permanent för att upprätthålla äkthet och värde. Personlig kontaktinformation behålls endast så länge du äger det digitala konstverket. Du kan begära datauppdateringar men ägarhistorik förblir för äkthet."
        },
        yourRights: {
          title: "Dina Rättigheter",
          content: "Som premiumägare har du förstärkta rättigheter: tillgång till all ägardata, möjlighet att uppdatera kontaktinformation, överföra ägarregistreringar och begära premium integritetskonsultationer. Ägandet i sig kan inte raderas eftersom det är en del av den permanenta exklusivitetsregistreringen."
        },
        contact: {
          title: "Kontakta Oss",
          content: "För premium integritetssupport, kontakta oss från hemsidan. Premiumägare får prioriterad integritetshjälp."
        }
      }
    },
    
    // Nero Diamante Terms of Use
    neroDiamanteTerms: {
      title: "Nero Diamante Användarvillkor",
      lastUpdated: "Senast uppdaterad: 26 juni 2025",
      sections: {
        acceptance: {
          title: "Acceptans av Villkor",
          content: "Genom att köpa och använda Nero Diamante, godkänner du dessa exklusiva användarvillkor. Dessa villkor styr ditt ägande och användning av detta begränsade digitala konstverk."
        },
        exclusivity: {
          title: "Exklusivitetsavtal",
          content: "Nero Diamante är begränsat till exakt 1000 stycken världsomfattande. Ditt köp ger dig exklusivt ägande av ett unikt stycke, identifierat av ditt personliga certifikatnummer. Inga ytterligare stycken kommer någonsin att skapas utöver denna gräns."
        },
        ownership: {
          title: "Digitala Äganderättigheter",
          content: "Du äger exklusiva rättigheter till ditt specifika Nero Diamante-stycke, inklusive: permanent tillgång till den interaktiva konstupplevelsen, överföringsrättigheter till framtida ägare, äkta ägarcertifikat och livstids mjukvaruuppdateringar och premiumsupport."
        },
        usage: {
          title: "Tillåten Användning",
          content: "Du får använda din Nero Diamante för personlig njutning, visning, insamling och överföring till andra parter. Du får inte reproducera, kopiera, distribuera eller skapa härledda verk från den digitala konsten för kommersiella ändamål."
        },
        transfers: {
          title: "Ägandeöverföring",
          content: "Nero Diamante-ägande kan överföras till andra parter. Överföring kräver identitetsverifiering och resulterar i permanenta registeruppdateringar. Överföringsavgifter kan tillkomma. Den nya ägaren får fullständiga äganderättigheter och uppdaterade certifikat."
        },
        authenticity: {
          title: "Äkthetsgaranti",
          content: "Varje Nero Diamante kommer med ett äkthetscertifikat garanterat av Sunny Software. Förfalskning eller obehörig reproduktion är strängt förbjuden och kan resultera i rättsliga åtgärder."
        },
        value: {
          title: "Värde och Investering",
          content: "Även om Nero Diamante representerar premium digital konst, ger Sunny Software inga garantier om framtida värde eller investeringsavkastning. Digital konsts värde kan fluktuera baserat på marknadsförhållanden och efterfrågan."
        },
        technical: {
          title: "Tekniska Krav",
          content: "Nero Diamante kräver kompatibla iOS-enheter för optimal upplevelse. Mjukvaruuppdateringar kommer att tillhandahållas för att upprätthålla kompatibilitet och förbättra funktioner. Premium teknisk support ingår med ägandet."
        },
        limitation: {
          title: "Ansvarsbegränsning",
          content: "Sunny Softwares ansvar är begränsat till det ursprungliga köpeskillingen. Vi är inte ansvariga för några indirekta skador, förlorade vinster eller följdskador relaterade till ägande eller användning av Nero Diamante."
        },
        termination: {
          title: "Uppsägning",
          content: "Dessa villkor förblir i kraft så länge du äger ditt Nero Diamante-stycke. Sunny Software kan avsluta supporttjänster för överträdelser av dessa villkor, men dina äganderättigheter förblir intakta."
        },
        changes: {
          title: "Ändringar av Villkor",
          content: "Vi förbehåller oss rätten att modifiera dessa villkor. Väsentliga ändringar som påverkar äganderättigheter kommer att kommuniceras med minst 90 dagars varsel till alla nuvarande ägare."
        },
        contact: {
          title: "Kontaktinformation",
          content: "För frågor om dessa villkor eller ägandefrågor, kontakta oss från hemsidan. Premiumägare får snabb support."
        }
      }
    }
  }
};